import React from 'react';
import { View } from 'react-native';

import { makeStyles } from '@providers/Theme';

import { BlurViewProps } from './types';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'rgba(52, 64, 84, 0.7)',
    backdropFilter: 'blur(5px)',
  },
}));

export const BlurView: React.FC<BlurViewProps> = ({ children, style }) => {
  const styles = useStyles();
  return <View style={[style, styles.root]}>{children}</View>;
};
